import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/admin_users_role_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  admin_user_email_cont: {
    model_name: 'AdminUser',
    column_type: 'string',
    label_key_path: 'adminUser.email',
  },
  role_kind_eq: {
    column_type: 'enum',
    extra: {
      options: ['super', 'application', 'designer', 'merchandiser', 'salesman', 'not_any', 'custom', 'sales_director', 'supplier', 'supplier_boss', 'cheif_pattern_making_officier', 'pattern_maker', 'craftsman', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    model_name: 'Role',
    label_key_path: 'role.kind',
  },
  role_kind_in: {
    column_type: 'has_many',
    label_key_path: 'adminUsersRole.role',
    model_name: 'AdminUsersRole',
    extra: {
      model_name: 'Role',
      value_column: 'kind',
      display_column: 'name',
    },
  },
}
export const formColumnsConfig = {
  'self': {
    'role_id': { required: true, disabledUpdate: false },
    'admin_user': { required: true, disabledUpdate: true },
  },
  'admin_user': {
    'email': { required: true, disabledUpdate: true },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('AdminUsersRole', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('AdminUsersRole', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
